module.exports = __webpack_public_path__ + "static/media/pickle_680_gr.b0eb6162.png";